import styles from './ApplicationMainDrawer.module.css'
import { useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import { SwipeableDrawer } from '@mui/material'
import { ApplicationMainDrawerMenu } from './ApplicationMainDrawerMenu'
import { useReadMonitorsShortQuery } from 'services/monitor'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { drawerWidth } from 'config'
import { useAppSelector, useAppDispatch } from 'shared/hooks'
import { selectDrawerOpen, setDrawerOpen } from 'store/applicationSlice'
import { useEffect } from 'react'

export const ApplicationMainDrawer = () => { 
    const location = useLocation()
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('xs'));
    const dispatch = useAppDispatch()
    const drawerOpen = useAppSelector(selectDrawerOpen)

    useEffect(() => {
        if (matches) {
            dispatch(setDrawerOpen(false))
        }
    }, [
        location
    ])

    const toggleDrawer = (open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    (
                        (event as React.KeyboardEvent).key === 'Tab'
                        || (event as React.KeyboardEvent).key === 'Shift'
                    )
                ) {
                    return;
                }

                dispatch(setDrawerOpen(open))
        }

    return (
        <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        >
            <SwipeableDrawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, paddingTop: '84px' },
                }}
                open
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
            >
                <div className={styles.ApplicationMainDrawer__MenuContainer}>
                    <ApplicationMainDrawerMenu></ApplicationMainDrawerMenu>
                </div>
            </SwipeableDrawer>
        </Box>
    )
}
